import React from "react"
import { Link } from "react-router-dom"

import { Section, SectionTitle, Text } from "@jewlr/storybook/info"
import { Box } from "components/common/index"
import { jewlr_t } from "helpers/application"

const MostInnovative = () => (
  <Box mb={7}>
    <Section>
      <Box contain>
        <SectionTitle>
          Jewlr Named Most Innovative Retailer In 2013 Canada Post E-Commerce
          Innovation Awards
        </SectionTitle>
        <Text>
          <strong>THORNHILL, ONTARIO--(Marketwired - Sept. 26, 2013) -</strong>{" "}
          At a gala held last night at the Metro Toronto Convention Centre,{" "}
          <Link data-lc="most-innovative" to="/">
            Jewlr
          </Link>{" "}
          took home top honours in the 2013 Canada Post E-commerce Innovation
          Awards . Recognized by the judging panel for its innovative business
          model in delivering {jewlr_t("terms.personalized")}{" "}
          {jewlr_t("terms.jewelry")} and for providing a superior online
          customer experience, Jewlr was named the{" "}
          <em>Most Innovative (Large) Retailer</em>. Jewlr will share a $1
          million total prize package - which includes{" "}
          {jewlr_t("terms.shipping")} services and customized direct marketing
          packages - with seven other retailers that were recognized in their
          specific categories.{" "}
        </Text>
        <Text>
          &quot;Canadian shoppers have increasingly high expectations when it
          comes to online user experience, product selection,{" "}
          {jewlr_t("terms.shipping")} and returns solutions, and customer
          engagement,&quot; says Ren&#233; Desmarais, Senior Vice-President,
          Parcels, Canada Post. &quot;Jewlr is among a select group of
          innovators that are pushing the boundaries and creating opportunities
          for homegrown commerce. We are very pleased to recognize and support
          their success.&quot;
        </Text>
        <Text>
          Jewlr is at the forefront of the movement towards{" "}
          <Link
            data-lc="most-innovative"
            to={`/${jewlr_t("terms.personalized")}-${jewlr_t("terms.jewelry")}`}
          >
            {jewlr_t("terms.personalized")} {jewlr_t("terms.jewelry")}
          </Link>
          . The company combines innovative custom design technology, 3D
          printing and traditional handmade manufacturing to deliver high
          quality, stylish and {jewlr_t("terms.personalized")}{" "}
          {jewlr_t("terms.jewelry")} - including{" "}
          <Link data-lc="most-innovative" to="/rings">
            Rings
          </Link>
          ,{" "}
          <Link data-lc="most-innovative" to="/pendants">
            Pendants
          </Link>
          ,{" "}
          <Link data-lc="most-innovative" to="/personalized-charms">
            Charms
          </Link>{" "}
          or{" "}
          <Link data-lc="most-innovative" to="/earrings">
            Earrings
          </Link>{" "}
          - that is manufactured and shipped in a matter of days. Consumers
          looking for that perfect piece of {jewlr_t("terms.jewelry")} for
          themselves or as a gift can choose their {jewlr_t("terms.favorite")}{" "}
          style, stone (e.g., emeralds, sapphires, birthstones, diamonds -
          genuine, synthetic or Swarovski Zirconia stones), metal (e.g., silver,
          gold or tungsten), and engravings. All {jewlr_t("terms.jewelry")}{" "}
          orders include free {jewlr_t("terms.shipping")} and a 99-day
          &quot;hassle-free&quot; returns policy.
        </Text>
      </Box>
    </Section>
  </Box>
)
export default MostInnovative
